import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

/* Layout */
import Layout from '@/layout';

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export var constantRoutes = [{
  path: '/404',
  component: function component() {
    return import('@/views/404');
  },
  hidden: true
}, {
  path: '/',
  component: Layout,
  redirect: '/index',
  children: [{
    path: 'index',
    name: 'Index',
    component: function component() {
      return import('@/views/home');
    },
    meta: {
      title: '首页'
    }
  }]
}, {
  path: '/introduce',
  component: Layout,
  children: [{
    path: '',
    name: 'Introduce',
    component: function component() {
      return import('@/views/introduce/index.vue');
    },
    meta: {
      title: '招商服务'
    }
  }]
}, {
  path: '/guide',
  component: Layout,
  children: [{
    path: '',
    name: 'Guide',
    component: function component() {
      return import('@/views/guide/index.vue');
    },
    meta: {
      title: '新手用户操作指南'
    }
  }]
}, {
  path: '/famousCompany',
  component: Layout,
  children: [{
    path: 'index',
    name: 'index',
    component: function component() {
      return import('@/views/famousCompany/index/index.vue');
    },
    meta: {
      title: '名企列表'
    }
  }, {
    path: 'detail',
    name: 'detail',
    component: function component() {
      return import('@/views/famousCompany/detail/index.vue');
    },
    meta: {
      title: '名企详情'
    }
  }]
}, {
  path: '/login',
  component: Layout,
  children: [{
    path: '',
    name: 'Login',
    component: function component() {
      return import('@/views/login/index.vue');
    },
    meta: {
      title: '登录'
    }
  }]
}, {
  path: '/password',
  component: Layout,
  children: [{
    path: '',
    name: 'Password',
    component: function component() {
      return import('@/views/password/index.vue');
    },
    meta: {
      title: '修改密码'
    }
  }]
}, {
  path: '/add',
  component: Layout,
  children: [{
    path: '',
    name: 'Add',
    component: function component() {
      return import('@/views/add/index.vue');
    },
    meta: {
      title: '添加企业'
    }
  }]
}, {
  path: '/register',
  component: Layout,
  children: [{
    path: '',
    name: 'Register',
    component: function component() {
      return import('@/views/register/index.vue');
    },
    meta: {
      title: '企业注册'
    }
  }]
},
// 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];
var createRouter = function createRouter() {
  return new Router({
    base: '/',
    mode: 'history',
    // require service support
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;